import { RepositoryFactory } from '@/repository/factory/repositoryFactory';
import {
  createModule,
  action,
  mutation,
} from 'vuex-class-component';
import {
  FindFileContentQueryDto,
  FindFileContentResponse,
  FindFilesQueryDto,
  FindFilesResponse
} from '@/@types/theoryGit/files';

const VuexModule = createModule({
  namespaced: 'theoryGitFilesStore',
  strict: false,
});

export class FilesStore extends VuexModule {
  private readonly filesRepository = RepositoryFactory.theoryGit.filesRepository();
  /**state */
  private files: FindFilesResponse | null = null;
  private fileContent: FindFileContentResponse | null = null;
  private readMeContent: FindFileContentResponse | null = null;

  @mutation
  private setFiles(payload: FindFilesResponse) {
    this.files = payload;
  }

  @mutation
  private setFileContent(payload: FindFileContentResponse) {
    this.fileContent = payload;
  }

  @mutation
  private setReadMeContent(payload: FindFileContentResponse) {
    this.readMeContent = payload;
  }

  @mutation
  private init(payload: null) {
    this.files = null;
    this.fileContent = null;
    this.readMeContent = null;
  }

  /**ファイル名一覧取得 */
  @action
  async fetchFiles(params: {
    repositoryInfoId: number,
    query: FindFilesQueryDto,
  }) {
    const results = await this.filesRepository.findFiles(
      params.repositoryInfoId,
      params.query,
    );
    this.setFiles(results);
  }

  /**ファイル内容取得 */
  @action
  async fetchFileContent(params: {
    repositoryInfoId: number,
    query: FindFileContentQueryDto,
  }) {
    const results = await this.filesRepository.findFileContent(
      params.repositoryInfoId,
      params.query,
    );
    this.setFileContent(results);
  }

  /**README.mdの内容を取得 */
  @action
  async fetchReadMeContent(params: {
    repositoryInfoId: number,
    query: FindFileContentQueryDto,
  }) {
    const results = await this.filesRepository.findFileContent(
      params.repositoryInfoId,
      params.query,
    );
    this.setReadMeContent(results);
  }

  @action
  async initState() {
    this.init(null);
  }

  get getFiles() {
    return this.files;
  }

  get getFileContent() {
    return this.fileContent;
  }

  get getReadMeContent() {
    return this.readMeContent;
  }
}
